/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Wise_Ox_ScanInputs */

const en_crisp_wise_ox_scan = /** @type {(inputs: Crisp_Wise_Ox_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send notification`)
};

const de_crisp_wise_ox_scan = /** @type {(inputs: Crisp_Wise_Ox_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigung senden fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed to send notification" |
*
* @param {Crisp_Wise_Ox_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_wise_ox_scan = /** @type {((inputs?: Crisp_Wise_Ox_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Wise_Ox_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_wise_ox_scan(inputs)
	return de_crisp_wise_ox_scan(inputs)
});